export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/['']/g, '')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');
}

export function tourUrl(id: string, title: string): string {
  return `/aruba/${slugify(title)}-${id.slice(0, 8)}`;
}

export function extractIdPrefix(slugWithId: string): string {
  const parts = slugWithId.split('-');
  return parts[parts.length - 1]; // last 8 chars = id prefix
}

export function companyUrl(companyName: string): string {
  return `/aruba/${slugify(companyName)}`;
}
